import apiClient from './api';
import { VoucherDto, CreateVoucherDto, UpdateVoucherDto } from '../types/vouchers.types';

class CheckReceiptsService {
  private baseUrl = `/vouchers`;

  async getAll(): Promise<VoucherDto[]> {
    const response = await apiClient.get(`${this.baseUrl}/type/CHR`);
    return response.data.data || response.data;
  }

  async getById(id: number): Promise<VoucherDto> {
    const response = await apiClient.get(`${this.baseUrl}/${id}`);
    return response.data.data || response.data;
  }

  async create(dto: CreateVoucherDto): Promise<VoucherDto> {
    const response = await apiClient.post(this.baseUrl, dto);
    return response.data.data || response.data;
  }

  async update(id: number, dto: UpdateVoucherDto): Promise<VoucherDto> {
    const response = await apiClient.put(`${this.baseUrl}/${id}`, dto);
    return response.data.data || response.data;
  }

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${this.baseUrl}/${id}`);
  }

  async post(id: number): Promise<VoucherDto> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/post`);
    return response.data.data || response.data;
  }

  async unpost(id: number): Promise<VoucherDto> {
    const response = await apiClient.post(`${this.baseUrl}/${id}/unpost`);
    return response.data.data || response.data;
  }

  async getByStatus(status: string): Promise<VoucherDto[]> {
    const response = await apiClient.get(`${this.baseUrl}/status/${status}`);
    return response.data.data || response.data;
  }

  async getByDateRange(startDate: string, endDate: string): Promise<VoucherDto[]> {
    const response = await apiClient.get(`${this.baseUrl}/daterange`, {
      params: { startDate, endDate, type: 'CHR' }
    });
    return response.data.data || response.data;
  }
}

export const checkReceiptsService = new CheckReceiptsService();